/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Export_CancelledInputs */

const en_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export cancelled by user.`)
};

const fr_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation annulée par l’utilisateur.`)
};

const de_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export vom Benutzer abgebrochen.`)
};

const it_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione annullata dall'utente.`)
};

const ru_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт отменен пользователем.`)
};

const es_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación cancelada por el usuario.`)
};

const zh_cn2_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户取消了导出操作。`)
};

const ja_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートはユーザーによってキャンセルされました。`)
};

const hi_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता द्वारा निर्यात रद्द कर दिया गया।`)
};

const pt_pt2_ateliere_connect_export_cancelled = /** @type {(inputs: Ateliere_Connect_Export_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação cancelada pelo usuário.`)
};

/**
* | output |
* | --- |
* | "Export cancelled by user." |
*
* @param {Ateliere_Connect_Export_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_export_cancelled = /** @type {((inputs?: Ateliere_Connect_Export_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Export_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_export_cancelled(inputs)
	if (locale === "de") return de_ateliere_connect_export_cancelled(inputs)
	if (locale === "it") return it_ateliere_connect_export_cancelled(inputs)
	if (locale === "ru") return ru_ateliere_connect_export_cancelled(inputs)
	if (locale === "es") return es_ateliere_connect_export_cancelled(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_export_cancelled(inputs)
	if (locale === "ja") return ja_ateliere_connect_export_cancelled(inputs)
	if (locale === "hi") return hi_ateliere_connect_export_cancelled(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_export_cancelled(inputs)
	return en_ateliere_connect_export_cancelled(inputs)
});